import { createPaginatedKey } from "api/keys";

export const productsKeysNew = {
  product: (id: string) => ["product", id],
  categories: {
    list: createPaginatedKey("productCategories"),
  },
};
